import { render, staticRenderFns } from "./StepsOfEditionCanvas.vue?vue&type=template&id=254c867e&"
import script from "./StepsOfEditionCanvas.vue?vue&type=script&lang=js&"
export * from "./StepsOfEditionCanvas.vue?vue&type=script&lang=js&"
import style0 from "./StepsOfEditionCanvas.vue?vue&type=style&index=0&id=254c867e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports